import { FeedItemDto, ResponseDto } from '@act/shared/data-transfer-objects';
import { Typography } from '@mui/material';
import SurveySummary from 'react-components/survey/survey-summary';
import { selectAllUserResponses } from 'redux/slices/legacySurveySlice';
import { userAppSelectors } from 'redux/slices/usersSlice';
import { selectAssignedWorkflowPhaseById } from 'redux/slices/workflowSlice';
import { useAppSelector } from 'redux/store-hooks';
import InfoCard from 'toolkit/info-card/info-card';
import { ContentPreview, FlexContainer, TaggableChip } from '@act/storybook';

interface FeedCompletedWorkflowPhaseCardProps {
  feedItem: FeedItemDto;
  shouldHighlight: boolean;
}

const CompletedWorkflowPhaseFeedCard = ({
  feedItem,
  shouldHighlight,
}: FeedCompletedWorkflowPhaseCardProps) => {
  function getSurveyResponseIndex(responses: ResponseDto[]): number {
    return responses?.findIndex(
      r => r.id === assignedWorkflowPhase?.surveyResponseId
    );
  }

  const assignedWorkflowPhase = useAppSelector(
    selectAssignedWorkflowPhaseById(feedItem?.externalItemId)
  );
  const userResponses = useAppSelector(selectAllUserResponses);

  const userName = userAppSelectors.useSelectUserById(
    userResponses?.[getSurveyResponseIndex(userResponses)]?.completingGuideId
  )?.name;

  // If assignedWorkflowPhase doesn't exist (e.g., after deletion), don't render the component
  if (!assignedWorkflowPhase) {
    return null;
  }

  return (
    <InfoCard
      variant="task"
      subject={assignedWorkflowPhase?.['workflowPhase']?.title}
      startTime={feedItem.createdAt}
      statusChips={[
        <TaggableChip
          color="success"
          variant="filled"
          label="Complete"
          isTag
        />,
      ]}
      shouldHighlight={shouldHighlight}
    >
      <FlexContainer
        direction="column"
        width="100%"
        height="fit-content"
        gap={1}
      >
        <Typography variant="labelLarge">
          {userName}
          {' completed '}
          {assignedWorkflowPhase?.['workflowPhase']?.title}
        </Typography>
        <ContentPreview>
          <SurveySummary
            surveyResponseId={assignedWorkflowPhase?.surveyResponseId}
          />
        </ContentPreview>
      </FlexContainer>
    </InfoCard>
  );
};

export default CompletedWorkflowPhaseFeedCard;
